<template>
  <div>
    <PageHeader :schema="$schemas.costCenter" />
    <PageContent>
      <DynamicListPage
        :schema="$schemas.costCenter"
        :service="$api.costCenters"
      />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicListPage from '@/components/dynamics/DynamicListPage';

export default {
  name: 'ListCostCenters',
  components: { PageHeader, PageContent, DynamicListPage },
};
</script>
